import { render, staticRenderFns } from "./modal-setting.component.vue?vue&type=template&id=292f95e6&scoped=true"
import script from "./modal-setting.component.vue?vue&type=script&lang=js"
export * from "./modal-setting.component.vue?vue&type=script&lang=js"
import style0 from "./modal-setting.component.vue?vue&type=style&index=0&id=292f95e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "292f95e6",
  null
  
)

export default component.exports